export const PROPERTIES = "PROPERTIES";
export const PROPERTY = "PROPERTY";
export const PROPERTY_UPDATED = "PROPERTY_UPDATED";
